<template>
  <iframe v-if="url" :src="url" width="100%" height="100%" frameborder="0"></iframe>
</template>

<script>
import {geipUrl} from '@/assets/js/config'
import { getCookie } from '@/assets/utils/CommonUtil'
export default {
  data () {
    return {
      url: ''
    }
  },
  created () {
    this.url = ''
    const query = this.$route.query
    const token = query.token || getCookie('accountToken') || null
    if (token){
      this.url = geipUrl + `/login/free-license?viewMode=freeLicense&geipToken=${token}`
    } else {
      this.url = geipUrl + '/login/free-license?viewMode=freeLicense'
    }
  }
}
</script>
